export default "__VITE_ASSET__Cbtde9Ys__"